import { cleanName } from '../../../common/utils/text';

// Validación client-side. El contrato no fija longitudes; estos topes son solo
// guardas de UI — si el backend (Joi) es más estricto, sus errores llegan por
// ApiError.fields. `code` es el identificador (único, inmutable tras crear).
const MAX_CODE = 60;
const MAX_NAME = 120;
const CODE_RE = /^[A-Z0-9_]+$/;

export function validateTemplate(form, { isEdit = false } = {}) {
    const errors = {};

    if (!isEdit) {
        const code = (form.code || '').trim();
        if (!code) errors.code = 'El código es obligatorio.';
        else if (!CODE_RE.test(code)) errors.code = 'Solo mayúsculas, números y guion bajo (p. ej. PARTO_REGISTRADO).';
        else if (code.length > MAX_CODE) errors.code = `Máximo ${MAX_CODE} caracteres.`;
    }

    const name = cleanName(form.name);
    if (!name) errors.name = 'El nombre es obligatorio.';
    else if (name.length > MAX_NAME) errors.name = `Máximo ${MAX_NAME} caracteres.`;

    return errors;
}
